import { Component, OnInit } from '@angular/core';

import { BaseComponent } from '../../base/base.component';
import { WizardService } from '../../../services/wizard/wizard.service';
import { EventService } from '../../../services/event/event.service';
import { ErrorService } from '../../../services/error/error.service';

import { AvailabilityType, IDropdown, IDefaultWizardOptions } from 'common-lib';

declare var $: any;
import * as _ from 'lodash';
@Component({
    selector: 'wizard-meeting-type',
    templateUrl: './meeting-type-dropdown.component.html',
    styleUrls: ['./meeting-type-dropdown.component.scss', '../../form-styles.scss']
})
export class MeetingTypeDropdownComponent extends BaseComponent implements OnInit {
    private selectedMeetingType = '';
    private meetingTypes: IDropdown[] = [{ name: 'Meeting', value: 'meeting', selected: true }];
    public availabilityTypeText = '';
    public showWarning = false;

    constructor(
        public wizardService: WizardService,
        private errorService: ErrorService,
        private eventService: EventService
    ) {
        super();
    }

    ngOnInit() {
        this.meetingTypes = this.getMeetingTypes();
        this.selectedMeetingType = this.getInitialMeetingType(this.wizardService.meetingType, this.meetingTypes);
        this.setDefaultMeetingType(this.selectedMeetingType);
        this.initSemantic();
    }

    private getMeetingTypes() {
        return this.data?.mode === 'group-class'
            ? this.wizardService.meetingTypes.class
            : this.wizardService.meetingTypes.meeting;
    }

    private getInitialMeetingType(selectedMeetingType: string, meetingTypes: IDropdown[]) {
        if (selectedMeetingType) {
            return selectedMeetingType;
        } else {
            return meetingTypes.filter((type) => type.selected === true)[0]?.name || 'meeting';
        }
    }

    private setDefaultMeetingType(selectedMeetingType: string) {
        if (this.wizardService.options.type) {
            this.availabilityTypeText = this.getAvailabilityTypeText(this.wizardService.options.availabilityType);
            return;
        }

        this.updateMeetingType(selectedMeetingType);
    }

    private updateMeetingType(val: string) {
        this.selectedMeetingType = val;
        this.wizardService.updateMeetingType(val, this.data?.mode === 'group-class');

        const contacts = this.wizardService.options.contacts;
        const payloadKeys = ['dateEnd', 'dateStart', 'type'];
        if (contacts?.length) payloadKeys.push('contacts');
        this.eventService.requestDefaultOptions(payloadKeys).subscribe(
            (response: { data: IDefaultWizardOptions }) => {
                const { data } = response;
                this.wizardService.updateDefaultOptions(data);
                this.availabilityTypeText = this.getAvailabilityTypeText(response.data.availabilityType);
                this.showWarning = this.shouldShowBookingCalendarWarning(data.calendarProviderType);
            },
            (error: string) => {
                this.errorService.setServerError(error);
            }
        );
    }

    private getAvailabilityTypeText(availabilityType: AvailabilityType) {
        const simpleAvailabilityType = this.getSimpleAvailabilityType(availabilityType);

        this.wizardService.updateOptions({
            availabilityType: availabilityType
        });

        switch (simpleAvailabilityType) {
            case 'round-robin':
                return 'Round-Robin';
            case 'collective':
                return availabilityType === 'some-internal-users-collective' ||
                    this.wizardService.options.contacts.length > 1
                    ? 'Collective'
                    : null;
            case 'on-behalf':
                return 'On-Behalf';
            case 'external on-behalf':
                return 'External On-Behalf';
            default:
                return null;
        }
    }

    private initSemantic() {
        $('#type').dropdown({
            values: this.meetingTypes,
            onChange: (value) => {
                if (value && value !== this.selectedMeetingType) {
                    this.updateMeetingType(value);
                }
            }
        });
    }

    // TODO: this method is copied from meetingTypesService
    private getSimpleAvailabilityType(availabilityType?: AvailabilityType) {
        switch (availabilityType) {
            case 'all-internal-users-round-robin':
            case 'all-internal-users-round-robin-no-organizer':
            case 'some-internal-users-round-robin':
                return 'round-robin';
            case 'all-internal-users-collective':
            case 'all-internal-users-collective-no-organizer':
            case 'some-internal-users-collective':
                return 'collective';
            case 'on-behalf':
                return 'on-behalf';
            case 'external-on-behalf':
                return 'external on-behalf';
            default:
                return 'your';
        }
    }

    private shouldShowBookingCalendarWarning(providerType?: string) {
        return this.data?.mode === 'group-class' && ['microsoft graph', 'exchange graph'].indexOf(providerType) > -1;
    }
}
